<template>
  <div class="__tailwind">
    <LayoutSelector
      v-model:open="open"
      v-model:selected-prop-value="newLayout"
      :layouts="ENTRY_LAYOUTS"
    />
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import LayoutSelector from "@/cms/dialogs/LayoutSelector/LayoutSelector.vue";
import { ENTRY_LAYOUTS } from "@/components/CMSComponents/layoutOptions.ts";

const props = defineProps({
  selectedItems: {
    type: Array,
    required: true,
  },
});

const store = useStore();
const route = useRoute();

const newLayout = ref("");

const allSelectedItemsHaveSameLayout = computed(
  () =>
    props.selectedItems.length &&
    props.selectedItems.every((v) => v.layout === props.selectedItems[0].layout)
);

const open = ref(false);

const getBulkPatchObject = (attribute, attributeValue) =>
  props.selectedItems.map((item) => ({
    path: item.path,
    update: { [attribute]: attributeValue },
    categoryID: route.params.categoryID,
    entryID: item.path.split("entry/")[1],
  }));

const changeLayoutOfSelectedProfiles = async (layoutName) => {
  const updates = getBulkPatchObject("layout", layoutName);
  if (updates.length) {
    await store.dispatch("api/patchEntriesBulk", {
      updates,
      opts: { updateStoreFirst: true, isCms: true },
    });
  }
};

const showModal = () => {
  open.value = true;
};

const changeAllLayouts = async (layoutName) => {
  open.value = false;

  if (props.selectedItems.length === 0) {
    const doc = {
      layout: layoutName,
    };
    await store.dispatch("api/updateEntries", {
      categoryID: route.params.categoryID,
      doc,
      opts: { updateStoreFirst: true, isCms: true },
    });
  } else {
    changeLayoutOfSelectedProfiles(layoutName);
  }
};

watch(
  () => newLayout.value,
  () => {
    if (
      !newLayout.value ||
      (allSelectedItemsHaveSameLayout.value &&
        newLayout.value === props.selectedItems[0].layout)
    ) {
      return;
    }

    changeAllLayouts(newLayout.value);

    newLayout.value = "";
  }
);

watch(
  () => open.value,
  () => {
    newLayout.value = allSelectedItemsHaveSameLayout.value
      ? props.selectedItems[0]?.layout
      : "";
  }
);

defineExpose({
  showModal,
});
</script>
